import { ReactElement, ReactNode, CSSProperties, memo } from 'react'
import PropTypes from 'prop-types'
import Image from 'next/image'

import SectionTitle from '@/components/SectionTitle'
import { ReactComponent as Group31 } from '@/svg/decorators/group-31.svg'
import { ReactComponent as Group379 } from '@/svg/decorators/group-379-4.svg'

import CheckedList from '@/features/landing/components/WhatProkit/CheckedList'

import ImageFile from '@/png/landing/two-businessman-investment-consultant-analyzing-company-financial-report@2x.png'

import Container from './style'

interface Props {
  children: ReactNode[]
  style?: CSSProperties
  className?: string
  id?: string
}

function WhatProKit({ id, className, style, children }: Props): ReactElement {
  return (
    <Container id={id} className={className} style={style}>
      <div className="decorator-container">
        <Group31 id="group-31" />
        <Group379 id="group-379-4" />
      </div>
      <div className="container">
        <h1>รวมทุกอย่างที่คุณต้องทำเพื่อเตรียมพร้อม PDPA</h1>
        <p>
          PDPA Prokit ช่วยให้คุณประหยัดเวลา ด้วยเอกสารที่ประกอบด้วย นโยบาย
          ขั้นตอน กระบวนการ  แบบฟอร์ม และเอกสารอื่น ๆ ที่คุณต้องการ
          เพื่อให้ปฏิบัติตาม พ.ร.บ. คุ้มครองข้อมูลส่วนบุคคล พ.ศ.&nbsp;2562 
          ได้อย่างถูกต้องครบถ้วน
          โดยผู้เชี่ยวชาญด้านกฎหมายที่ได้รับการรับรองเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล
        </p>
      </div>
      <div className="list-container">
        <section>
          <article className="image-container">
            <figure className="image">
              <Image
                src={ImageFile}
                alt="Documents"
                layout="fill"
                objectFit="cover"
              />
            </figure>
          </article>
          <article className="checked-list-container">
            <SectionTitle className="checked-list-title">
              <span>
                สิ่งที่คุณจะได้รับจาก PDPA{' '}
                <span className="primary">
                  PROKIT
                  <svg
                    viewBox="0 0 100 31"
                    className="rectangle"
                    preserveAspectRatio="none"
                  >
                    <rect x="0" y="16" width="100" height="2" />
                  </svg>
                  <svg viewBox="0 0 31 31" className="circle">
                    <circle cx="15" cy="16" r="15" />
                  </svg>
                </span>
              </span>
            </SectionTitle>
            <CheckedList>{children}</CheckedList>
          </article>
        </section>
      </div>
    </Container>
  )
}

WhatProKit.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element)])
    .isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
  id: PropTypes.string,
}

WhatProKit.defaultProps = {
  className: '',
}

export default memo(WhatProKit)
